import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import translationPT from './pt/translation.json'
import translationKR from './kr/translation.json'
import translationES from './es/translation.json'
import translationHI from './hi/translation.json'

// the translations
const resources = {
    pt: {
        translation: translationPT,
    },
    es: {
        translation: translationES,
    },
    kr: {
        translation: translationKR,
    },
    ko: {
        translation: translationKR,
    },
    hi: {
        translation: translationHI,
    },
}

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        },
    })
